var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.html
    ? _c(
        "div",
        {
          staticClass: "review-card-reply d-flex align-start rounded-20",
          class: _setup.isMobile ? "pa-4" : "review-card-reply--desktop pa-6",
        },
        [
          _setup.showLpuLogoPicture
            ? _c(_setup.LpuLogoPicture, {
                attrs: {
                  "img-class":
                    "review-card-reply__img flex-shrink-0 review-card-reply__img--contain",
                  contain: "",
                  width: "40",
                  height: "40",
                  alt: "",
                  loading: "lazy",
                  files: _setup.lpuLogoFiles,
                },
              })
            : _c("img", {
                staticClass: "review-card-reply__img flex-shrink-0",
                class: {
                  "review-card-reply__img--contain": !_setup.isDoctorReply,
                },
                attrs: {
                  src: _setup.avatarUrl,
                  width: "40",
                  height: "40",
                  alt: "",
                  loading: "lazy",
                },
              }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "review-card-reply__body d-flex flex-column ga-3 ml-4",
            },
            [
              _c("div", [
                _c("div", { staticClass: "text-subtitle-2 text--text" }, [
                  _vm._v("\n        " + _vm._s(_setup.title) + "\n      "),
                ]),
                _vm._v(" "),
                _setup.datetime
                  ? _c("div", { staticClass: "text-body-2 text-info--text" }, [
                      _vm._v(
                        "\n        " + _vm._s(_setup.datetime) + "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "review-card-reply__text text-body-1 text--text",
                },
                [
                  _c("div", {
                    class: {
                      "review-card-reply__text--truncated":
                        _setup.isTruncated && !_setup.isExpanded,
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _setup.html /* eslint-disable-line vue/no-v-html */
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _setup.isTruncated && !_setup.isExpanded
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "text-body-1 primary--text text-decoration-underline button-reset",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _setup.isExpanded = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.tStatic("Раскрыть")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }